module.exports = __webpack_public_path__ + "static/img/plat_06.9074652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/internetPlat/plat_06.jpg
// module id = OaW/
// module chunks = 1